import React from 'react'
import { getShapeBorderStyle, getLineShapeStyle, resolveTextStyle } from '../../lib/global/helpers'

export default function HTMLTotalTemplate(props) {
    const pageSettings = {
        'a4': {
            'width': 794,
            'height': 1123
        },
        'letter': {
            'width': 595,
            'height': 842
        }
    };

    const renderUploadedImages = (section) => {
        const images = props.properties?.[section]?.images;
        if (!images) return null;

        return Object.keys(images).map((key) => {
            const data = images[key];
            if (!data || !data.src) return null;

            return (
                <div
                    key={data.id || key}
                    style={data.style}
                    id={data.id}
                    data-element={data.name}
                    data-section={section}
                    data-path="images"
                    data-index={key}
                >
                    <img
                        src={data.src}
                        alt={data.alt || data.name || ''}
                        style={{ width: '100%', height: '100%', display: 'block' }}
                    />
                </div>
            );
        });
    };

    const renderElements = (section) => {
        return (
            props.properties &&
            props.properties[section]?.elements &&
            Object.keys(props.properties[section].elements).map((key) => {
                var data = props.properties[section].elements[key];
                if (!data) return null;

                var dStyle = Object.assign({}, data.style || {});
                dStyle = resolveTextStyle(dStyle, props.properties.total?.font, props.properties.prop);
                dStyle.left = dStyle.left ? parseInt(dStyle.left) : 0;
                dStyle.zIndex = 2;

                const dataIndex = data.name ? data.name.replace(/\./g, '') : (data.id || `element-${key}`);

                return (
                    <div
                        key={data.id || key}
                        style={dStyle}
                        id={data.id}
                        data-element={data.name || 'element'}
                        data-section={section}
                        data-path="elements"
                        data-index={dataIndex}
                    >
                        {data.text || ''}
                    </div>
                );
            })
        );
    };

    const renderVatSummary = () => {
        if (props.properties?.total?.VatSummary &&
            Object.keys(props.properties.total.VatSummary).length > 0) {
            var data = props.properties.total.VatSummary;
            var dStyle = Object.assign({}, data.style || {});
            dStyle = resolveTextStyle(dStyle, props.properties.total?.font, props.properties.prop);
            dStyle.zIndex = 2;

            const dataIndex = data.name ? data.name.replace(/\./g, '') : (data.id || 'vat-summary');

            return (
                <div
                    key={data.id || 'vat-summary'}
                    style={dStyle}
                    id={data.id}
                    data-element={data.name || 'VatSummary'}
                    data-section="VatSummary"
                    data-path="elements"
                    data-index={dataIndex}
                >
                    {data.text || ''}
                </div>
            );
        }
        return null;
    };

    const renderShapes = () => {
        if (!props.properties.total.shapes) return null;

        return Object.keys(props.properties.total.shapes)
            .filter(s => s !== 'border')
            .map((key) => {
                var prop = props.properties.total.shapes[key];
                if (!prop) return null;

                var sectionBorder = props.properties.total.shapes.border || {};
                var isLine = prop.name && prop.name.startsWith('line');
                var bgColor = prop.fillColor || sectionBorder.fillColor || '#FFFFFFFF';

                var dStyle = Object.assign(isLine ? {} : { minWidth: '32px', minHeight: '16px' }, prop.style || {});
                if (isLine) {
                    Object.assign(dStyle, getLineShapeStyle(prop, sectionBorder));
                } else {
                    Object.assign(dStyle, getShapeBorderStyle(prop, sectionBorder));
                    dStyle.background = bgColor;
                }
                dStyle.left = dStyle.left ? parseInt(dStyle.left) : 0;
                dStyle.top = dStyle.top ? parseInt(dStyle.top) : 0;
                dStyle.width = dStyle.width ? parseInt(dStyle.width) : 32;
                dStyle.zIndex = 1;

                return (
                    <div
                        key={key}
                        style={dStyle}
                        id={prop.id}
                        data-element={prop.name || 'shape'}
                        data-section={"total"}
                        data-path="shapes"
                        data-index={prop.data || key}
                    />
                );
            });
    };

    return (
        <div style={{ width: '100%', pageBreakInside: 'avoid', breakInside: 'avoid' }} className="total-section" data-layout={props.properties.total?.position === "aboveFooter" ? "total-above-footer" : "total-after-items"} data-total-position={props.properties.total?.position === "aboveFooter" ? "aboveFooter" : "afterItems"}>
            <div style={{
                height: props.properties.prop.orientation === "landscape"
                    ? props.heights.total * 0.01 * pageSettings[props.properties.prop.paperSize]?.width
                    : props.heights.total * 0.01 * pageSettings[props.properties.prop.paperSize]?.height,
                position: 'absolute',
                backgroundColor: props.properties.total.background.showColor
                    ? props.properties.total.background.color
                    : "transparent",
            }}>
                <div>
                    {renderElements("total")}
                    {renderVatSummary()}
                    {renderShapes()}
                    {renderUploadedImages("total")}
                </div>
            </div>
        </div>
    );
}